import React, { useRef, useEffect } from "react";
import { SubNavItem, ListItem, UL, Div } from "./styles";
import { useLocation } from "react-router-dom";
import { GetNav } from "../../StateManagement/Reducers/ScheduleState";
import { useDispatch } from "react-redux";

const ReportNav = () => {
  //------------------------------------------State and Variables Start------------------------------------------//

  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const dispatch = useDispatch();
  //------------------------------------------State and Variables End------------------------------------------//
  // ------------------------------- Functions Start--------------------------------------------------------- //

  const handleInputChange = (iconName) => (e) => {
    dispatch(GetNav(iconName));
  };

  const refMap = useRef({});

  // useEffect(() => {
  //   const keysToScroll = [
  //     "reminder",
  //     "EligibilityReport",
  //     "patientReport",
  //     "ProductivityReport",
  //     "OutgoingPrescription",
  //     "user",
  //     "invoice",
  //     "clinicalreport",
  //   ];
  //   const currentKey = splitLocation[2];
  //   if (keysToScroll.includes(currentKey) && refMap.current[currentKey]) {
  //     refMap.current[currentKey].scrollIntoView({
  //       behavior: "smooth",
  //       block: "center",
  //     });
  //   }
  // }, [splitLocation[2]]);

  // ------------------------------- Functions End--------------------------------------------------------- //

  return (
    <Div width="100%" paddingLeft="0.86em">
      <UL
        textAlign="left"
        width="100%"
        listStyleType="none"
        padding="0"
        margin="0"
        position="relative"
      >
        <ListItem
          padding="8px"
          margin="8px 0 0 0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem
            to="/report/billingsummary"
            id="rpt_nav-lnk_smry"
            exact
            className={
              (splitLocation[1] === "report" && splitLocation[2] === "nav") ||
              splitLocation[2] === "billingsummary"
                ? "active"
                : ""
            }
          >
            Billing Summary
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/report/daysheet" exact id="rpt_nav-lnk_pymnt">
            Payment Analysis
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/report/cardtransactions" exact>
            Card Transactions
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem
            to="/report/productprocedure"
            exact
            className={
              splitLocation[2] === "productprocedure" ||
              splitLocation[2] === "productprocedures"
                ? "active"
                : ""
            }
            id="rpt_nav-lnk_prod"
          >
            Product &amp; Procedures
          </SubNavItem>
        </ListItem>

        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/report/aging" exact id="rpt_nav-lnk_apmt">
            Aging Report
          </SubNavItem>
        </ListItem>
        {/* AccountReceivableReport sidenav */}
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
          ref={(el) => (refMap.current["clinicalreport"] = el)}
        >
          <SubNavItem to="/report/AccountReceivableReport" exact>
            Account Receivable Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem
            to="/report/invoice"
            exact
            id="rpt_nav-lnk_invo"
            ref={(el) => (refMap.current["invoice"] = el)}
          >
            Invoices
          </SubNavItem>
        </ListItem>

        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/report/refundreport" exact>
            Refund Report
          </SubNavItem>
        </ListItem>

        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
          ref={(el) => (refMap.current["clinicalreport"] = el)}
        >
          <SubNavItem to="/report/SuperbillReport" exact>
            Superbill Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem
            to="/report/PriorAuthorization"
            exact
            id="rpt_nav-lnk_pymnt"
          >
            Prior Authorization
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem
            to="/report/EligibilityReport"
            exact
            id="rpt_nav-lnk_pymnt"
            ref={(el) => (refMap.current["EligibilityReport"] = el)}
          >
            Eligibility Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
          ref={(el) => (refMap.current["clinicalreport"] = el)}
        >
          <SubNavItem to="/report/ClaimSubmissionReport" exact>
            Claim Submission Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
          ref={(el) => (refMap.current["clinicalreport"] = el)}
        >
          <SubNavItem to="/report/DenialAnalysisReport" exact>
            Denial Analysis Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
          ref={(el) => (refMap.current["clinicalreport"] = el)}
        >
          <SubNavItem to="/report/RejectionAnalysisReport" exact>
            Rejection Analysis Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/report/Remittance" exact id="rpt_nav-lnk_rmtnce">
            Remittance Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
          ref={(el) => (refMap.current["clinicalreport"] = el)}
        >
          <SubNavItem to="/report/WriteOffAdjustmentReport" exact>
            Write Off Adjustment Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
          ref={(el) => (refMap.current["clinicalreport"] = el)}
        >
          <SubNavItem to="/report/OutstandingBalanceReport" exact>
            Outstanding Balance Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
          ref={(el) => (refMap.current["clinicalreport"] = el)}
        >
          <SubNavItem to="/report/UnappliedCreditReport" exact>
            Unapplied Credit Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
          ref={(el) => (refMap.current["clinicalreport"] = el)}
        >
          <SubNavItem to="/report/clinicalreport" exact>
            Clinical Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/report/appointments" exact id="rpt_nav-lnk_apmt">
            Appointment Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem
            to="/report/reminder"
            exact
            ref={(el) => (refMap.current["reminder"] = el)}
          >
            Reminder Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem
            to="/report/ProductivityReport"
            exact
            id="rpt_nav-lnk_prRpt"
            ref={(el) => (refMap.current["ProductivityReport"] = el)}
          >
            Productivity Report
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem
            to="/report/user"
            exact
            id="rpt_nav-lnk_usrRpt"
            ref={(el) => (refMap.current["user"] = el)}
          >
            User Report
          </SubNavItem>
        </ListItem>

        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem
            to="/report/patientReport"
            exact
            ref={(el) => (refMap.current["patientReport"] = el)}
          >
            Patient Report
          </SubNavItem>
        </ListItem>

        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem
            to="/report/OutgoingPrescription"
            exact
            id="rpt_nav-lnk_otgPrsc"
            ref={(el) => (refMap.current["OutgoingPrescription"] = el)}
          >
            Outgoing Prescriptions
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem
            to="/report/IncomeAllocationReport"
            exact
            id="rpt_nav-lnk_incAlloc"
            ref={(el) => (refMap.current["IncomeAllocationReport"] = el)}
          >
            Income Allocation Report
          </SubNavItem>
        </ListItem>
      </UL>
    </Div>
  );
};

export default ReportNav;
